<template src="./Login.html"></template>
<script>
import mixins from "../../../../Mixins.js";
import { ToolIcon } from 'vue-feather-icons'

export default {
  components: {
    ToolIcon,
  },
  mixins: [mixins],
  data() {
    return {
      idWebClinic: null,
      email: "",
      password: "",
      checkbox_remember_me: true,
      bearer_code: "1",
      isHorasDaVida: false,
      seoMsg: "Bem-vindo à Filóo Saúde",
      options: {},
      invalidPassword: false,
      forgetPassword: false,
      passwordType: "password",
      invalidFields: {
        email: false,
        password: false,
      },
      loginClicked: false,
    };
  },
  watch: {
    email: function(newVal) {
      const vm = this;
      vm.invalidFields.email = (vm.testNullUndefinedEmpty(newVal) || !vm.validateEmail(newVal)) && (vm.loginClicked || vm.forgetPassword);
    },
    password: function(newVal) {
      const vm = this;
      vm.invalidFields.password = vm.testNullUndefinedEmpty(newVal);
    }
  },
  mounted: function() {
    const vm = this;
    vm.$vs.loading.close();
    if (vm.$cookies.get("user") !== null) {
      vm.email = vm.$cookies.get("user").userName;
      vm.password = this.$cookies.get("user").password;
    }
  },
  created: function () {
    const vm = this;
    if(vm.$route.name === "login-horas"){
      vm.isHorasDaVida = true;
      vm.seoMsg = "Bem-vindo ao Horas da Vida"
    }
  },
  methods: {
    newPassword() {
      const vm = this;
      vm.invalidFields.email = vm.testNullUndefinedEmpty(vm.email) || !vm.validateEmail(vm.email);
      if (!vm.invalidFields.email) {
        this.axios
        .post(vm.$store.state.filooServer + "users/forgot-password", {
          email: vm.email,
          type: "ADMIN"
        })
        .then(function() {
          vm.forgetPassword = false;
          vm.$swal(
            "Esqueci minha senha",
            "Um e-mail foi enviado para a configuração da sua nova senha.",
            "success"
          );
        })
        .catch(function() {
          vm.forgetPassword = false;
          vm.$swal(
            "Esqueci minha senha",
            "Ocorreu um erro ao enviar seu e-mail de renovação. Verifique se o mesmo foi digitado corretamente.",
            "warning"
          );
        });
      }
    },

    login() {
      const vm = this;
      vm.loginClicked = true;
      vm.invalidFields.email = vm.testNullUndefinedEmpty(vm.email) || !vm.validateEmail(vm.email);
      vm.invalidFields.password = vm.testNullUndefinedEmpty(vm.password);

      if( !vm.invalidFields.password && !vm.invalidFields.email) {
        vm.axios
          .post(vm.$store.state.filooServer + "admin/login", {
            username: vm.email,
            password: vm.password
          })
          .then(function(response) {
            if (response.status === 200) {
              vm.$session.start();
              vm.$session.set("bearer", response.headers.authorization);
              vm.$session.set("bearerDefault", response.headers.authorization);
              vm.bearer_code = response.headers.authorization;
              var user = { userName: vm.email, password: vm.password };
              if (vm.checkbox_remember_me === true) {
                vm.$cookies.set("user", user);
              } else {
                vm.$cookies.remove("user");
              }
              vm.getMe();
            }
          })
          .catch(function(){
            // vm.$bvModal.show("modal-under-maintenance");
            vm.invalidPassword = true;
          });
      }

    },
    getMe() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "me", {
          headers: { Authorization: vm.bearer_code }
        })
        .then(function(response) {
          vm.options = response.data;
          vm.$session.set("name", vm.options.name);
          vm.$session.set("email", vm.options.email);
          vm.$session.set("incomplete", vm.options.incomplete);
          vm.$session.set("authorities", vm.options.authorities);
          vm.$session.set("type", vm.options.type);
          vm.$session.set('id', vm.options.id);
          vm.$session.set("projectPhoto", vm.options.projectPhoto);
          vm.$session.set("isProject", vm.options.isProject);
          vm.$session.set("customerPlan", vm.options.customerPlan);
          vm.$session.set("optInStatus", vm.options.optInStatus)
          vm.$router.push("/general-page/main");
        });
    },
    getProfilePhoto() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "webclinics/photo/download/" + vm.idWebClinic, {
          headers: { Authorization: vm.bearer_code }
        })
        .then(function(response) {
          vm.$session.set("photo", response.data);
        });
    },

    passwordVisibility() {
      const vm = this;
      if (vm.passwordType === "password") {
        vm.passwordType = "text";
      } else {
        vm.passwordType = "password";
      }
    }
  }
};
</script>
<style  lang="scss" src="./Login.scss">
</style>
